import React, { useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { admin, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  useEffect(() => { if (admin) nav("/admin", { replace: true }); }, [admin, nav]);
  if (loading) return <div className="min-h-[60vh] grid place-items-center text-sakura-soft">Loading…</div>;
  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back!");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[70vh] section grid place-items-center" data-testid="page-admin-login">
      <form onSubmit={submit} className="card-soft p-8 md:p-10 w-full max-w-md" data-testid="admin-login-form">
        <div className="flex items-center gap-3">
          <span className="h-11 w-11 grid place-items-center rounded-full bg-sakura-200 text-sakura-500"><ShieldCheck className="h-5 w-5" /></span>
          <div>
            <h1 className="font-serif text-2xl text-sakura-ink">Admin Login</h1>
            <p className="text-sm text-sakura-soft">Sakura Treats · Order inquiries</p>
          </div>
        </div>

        <label className="block mt-6">
          <span className="text-sm font-semibold text-sakura-ink flex items-center gap-2"><Mail className="h-4 w-4 text-sakura-500" /> Email</span>
          <input className="input-soft mt-1" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email" />
        </label>
        <label className="block mt-4">
          <span className="text-sm font-semibold text-sakura-ink flex items-center gap-2"><Lock className="h-4 w-4 text-sakura-500" /> Password</span>
          <input className="input-soft mt-1" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password" />
        </label>

        <button type="submit" disabled={busy} className="btn-primary mt-6 w-full disabled:opacity-60" data-testid="admin-login-submit">
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
